module.exports = __webpack_public_path__ + "img/vivus.0053abaf.svg";